<template>
  <div>
    <Header v-if="!hidenHeader" />
    <main role="main" id="main_app">
      <slot />
    </main>
    <Footer v-if="!hidenFooter" />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: "simple",
  data() {
    return {
      hidenHeader: false,
      hidenFooter: false
    }
  },
  components: {
    Header,
    Footer
  },
  watch: {
    '$route': 'checkDisplayHeader'
  },
  mounted() {
    this.checkDisplayHeader()
  },
  methods: {
    checkDisplayHeader() {
      this.hidenHeader = this.$router.history.current.meta.hideHeader ? true : false;
      this.hidenFooter = (this.$router.history.current.meta.hideFooter==null||this.$router.history.current.meta.hideFooter) ? true : false;
    }
  }
}
</script>
<style lang="scss" scoped>
#main_app {
    min-height: calc(100vh - 204px);
}
</style>